
export const GetPropertyByPath = (path: string) => {
  if(path.includes('keyMetrics'))
    return 'keyMetric'
  if(path.includes('exams'))
    return 'exams'
  if(path.includes('accountability'))
    return 'accountability'
  if(path.includes('wellness'))
    return 'wellness'
  if(path.includes('actionItems'))
    return 'actionItems'
  return 'keyMetric'
}
